import { mountClassic } from '../render/classic/classic-app.js';
import { golfClassicSpec } from '../variants/golf/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(golfClassicSpec, { root, title: 'Golf' });
